export default __webpack_public_path__ + "static/media/tractor-icon.2eb8031a.svg";